module.exports = __webpack_public_path__ + "static/008163-6f26354dec9ee9a26e3c191326e2a74c.jpg";